import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { GeneralHtmlSupport } from '@ckeditor/ckeditor5-html-support';

/*
 * CKEditorでカスタムHTML要素（例：<x-italic>）をサポートするプラグイン
 * 参考：https://ckeditor.com/docs/ckeditor5/latest/features/html/general-html-support.html#enabling-custom-elements
 */

const customElements = [
  {
    name: 'x-italic',
    view: 'x-italic',
    model: 'xItalic',
    attributes: true,
    classes: true,
    styles: true,
  },
  // 以降に別のカスタムタグを追加できます
];

export default class CustomHtmlSupport extends Plugin {
  static get requires() {
    return [GeneralHtmlSupport];
  }
  init() {
    const dataFilter = this.editor.plugins.get('DataFilter');
    const dataSchema = this.editor.plugins.get('DataSchema');

    for (const element of customElements) {
      const { name, view, model, attributes, classes, styles } = element;

      dataSchema.registerInlineElement({
        view: view,
        model: model,
      });

      dataFilter.allowElement(name);
      dataFilter.allowAttributes({
        name: name,
        attributes: attributes || true,
        classes: classes || true,
        styles: styles || true,
      });
    }
  }
}
